import React from "react";
import { Trash2 } from "lucide-react";
import { useMarineWeather, sailingSafety } from "@/components/weather/useMarineWeather";
import { getTranslationsForLanguage } from "@/i18n";

export default function WatchSpotCard({ spot, onRemove, lang = "en" }) {
  const { data, isLoading } = useMarineWeather(spot.lat, spot.lng);
  const wind = Math.round(data?.forecast?.current?.wind_speed_10m ?? 0);
  const wave = Number(data?.marine?.current?.wave_height ?? 0);
  const safety = sailingSafety(wind, wave);
  const t = getTranslationsForLanguage(lang, "dailyBriefing").watchlist;

  return (
    <div className={`rounded-2xl border p-4 ${isLoading ? "border-border bg-background/70" : `${safety.border} ${safety.bg}`}`}>
      <div className="flex items-start justify-between gap-3">
        <div><b>{spot.name}</b><p className="text-sm text-muted-foreground">{isLoading ? t.checking : `${wind} kt · ${wave.toFixed(1)} m`}</p></div>
        {onRemove && <button type="button" onClick={() => onRemove(spot.id)} className="grid h-9 w-9 place-items-center rounded-xl text-muted-foreground hover:bg-background" aria-label={t.remove}><Trash2 className="h-4 w-4" /></button>}
      </div>
      {!isLoading && <span className={`mt-3 inline-flex rounded-full px-3 py-1 text-xs font-black ${safety.color}`}>{t.safety[safety.level] || safety.label}</span>}
    </div>
  );
}